<template lang="pug">
  div.text-left.pa-2
    .step1(v-if="currentStep == 1")
      .s1.basic100--text Click to update status
      .p2.basic100--text.mt-2 This button will change depending on an order’s current status. 
      .p2.basic100--text.mt-2 Status updates will always follow this sequence:
      .p2.basic100--text.font-weight-bold Processing
        v-icon.mx-1(small color="basic100") mdi-arrow-right
        | Ready
        v-icon.mx-1(small color="basic100") mdi-arrow-right
        | Shipping
        v-icon.mx-1(small color="basic100") mdi-arrow-right
        | Delivered
    .step2(v-if="currentStep == 2")
      .s1.basic100--text Get shipping documents
      .p2.basic100--text.mt-2 You can download your pick list, packing slip and AWB here.
    .step3(v-if="currentStep == 3")
      .s1.basic100--text Share with customers and riders
      .p2.basic100--text.mt-2 Easily share order receipts with your customers.
      .p2.basic100--text.mt-2 If you hire your own rider for deliveries, assign and share order details to your rider here.
    .step4(v-if="currentStep == 4")
      .s1.basic100--text WhatsApp your customers
      .p2.basic100--text.mt-2 Simply click this icon and we’ll take you to chat with your customer on WhatsApp.
    .step5(v-if="currentStep == 5")
      .s1.basic100--text Arrange shipment for this order
      .p2.basic100--text.mt-2 Make arrangements with your shipping and delivery integrations.
      .p2.basic100--text.mt-2 Then, we’ll mark this order as Arranged so you can keep track of orders that still require shipping arrangements.
      
    div.d-flex.mt-4
      .p2.basic100--text.my-auto {{currentStep}}/{{ tour.steps.length }}
      v-spacer
      v-btn.text-uppercase.my-auto.mr-2(v-if="currentStep != 1" small text @click="tour.previousStep")
        span.basic100--text.button-Aa-small Prev
      v-btn.text-uppercase.my-auto(v-if="currentStep == tour.steps.length" small :color="$vuetify.theme.themes[$theme].basic100" @click="clickFinish")
        span.basic800--text.button-AA-small Finish
      v-btn.text-uppercase.my-auto(v-else small :color="$vuetify.theme.themes[$theme].basic100" @click="tour.nextStep")
        span.basic800--text.button-AA-small Next
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'TourOrderDetails',
  props: {
    tour: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters({
      orderTempData: 'tours/getOrderTempData'
    }),
    currentStep () {
      return this.tour.currentStep + 1
    }
  },
  methods: {
    clickFinish () {
      this.$tours['YezzaTour'].stop()
      let data = {
        extra_data: {
          orderDetails: true
        }
      }
      if (this.orderTempData.extra_data) {
        data.extra_data = { ...this.orderTempData.extra_data, orderDetails: true }
        if (this.orderTempData.extra_data.calendarView && this.orderTempData.extra_data.kanbanView && this.orderTempData.extra_data.listView) {
          data.value = 'completed'
        }
      }
      this.$axios.patch(`/companies/${this.orderTempData.company}/settings/${this.orderTempData.id}`, data)
        .then(resp => {
          this.$store.commit('tours/setOrderTempData', { company: this.orderTempData.company, ...resp.data })
        })
    }
  }
}
</script>

<style scoped>
</style>